import {
  CreatePropertyPromotion,
  UpdatePropertyPromotion,
} from "../types/PropertyPromotion";
import { API_URL } from "../utils/ApiLinks";
import axios from "axios";

export class PropertyPromotionService {
  async create(data: CreatePropertyPromotion) {

    const promotion = {
      propertyId: data.propertyId,
      title: data.title === '' ? null : data.title,
      newPrice: data.newPrice === '' ? 0 : data.newPrice,
      colorText: data.colorText,
      colorTag: data.colorTag,
    };
    try {
      const response = await axios.post(
        `${API_URL}/propertyPromotion`,
        promotion
      );
      if (response.status === 201) {
        return this.handleSuccessResponse(response);
      }
    } catch (error: any) {
      return this.handleError(error);
    }
  }

  async update(id: number, data: UpdatePropertyPromotion) {
    try {
      const response = await axios.put(
        `${API_URL}/propertyPromotion/${id}`,
        data
      );

      if (response.status === 200) {
        return this.handleSuccessResponse(response);
      }
    } catch (error: any) {
      return this.handleError(error);
    }
  }

  async delete(id: number) {
    try {
      const response = await axios.delete(
        `${API_URL}/propertyPromotion/${id}`
      );

      if (response.status === 200) {
        return this.handleSuccessResponse(response);
      }
    } catch (error: any) {
      return this.handleError(error);
    }
  }

  handleError(error: any) {
    return { success: false, message: error.response.data.message, data : null };
  }

  handleSuccessResponse(response: any) {
    return {
      success: true,
      data: response.data.data,
      message: response.data.message,
    };
  }
}
